// extracted by mini-css-extract-plugin
export default {"children":"ChildrenParameter_children__etO7L","children__panel":"ChildrenParameter_children__panel__tscGP"};